import * as yup from "yup"
import { emailValidationSchema } from "../validations/courseREgistrationValidationSchemas"
import { getCountries } from "../../../lib/lists/countries"

const zipLengthRules: Record<string, RegExp> = {
  CZ: /^[1-7]\d{4}$/, // 10000 - 79999
  SK: /^[8-9]\d{4}$/, // 80000 - 99999
  DE: /^\d{5}$/, // 10000 - 99999
  PL: /^\d{5}$/, // 00001 - 99999
  AT: /^\d{4}$/ // 1000 - 9999
}

const registrationNoRules: Record<string, RegExp> = {
  CZ: /^\d{8}$/, // IČO: 8 čísel
  SK: /^\d{8}$/,
  DE: /^\d{9}$/, // Handelsregisternummer: 9 čísel
  PL: /^\d{10}$/, // REGON: 10 čísel
  AT: /^\d{8}$/ // Firmenbuchnummer: 8 čísel
}

const vatNoRules: Record<string, RegExp> = {
  CZ: /^CZ\d{8,10}$/, // DIČ: CZ + 8-10 čísel
  SK: /^SK\d{10}$/,
  DE: /^DE\d{9}$/,
  PL: /^PL\d{10}$/,
  AT: /^ATU\d{8}$/
}

export const invoiceSchema = yup.object().shape({
  name: yup.string(),
  email: emailValidationSchema.notRequired(),
  street: yup.string().required("Adresa je povinná."),
  city: yup.string().required("Město je povinné."),
  zip: yup
    .string()
    .test("is-valid-zip", "Neplatné PSČ pro vybranou zemi", function (value) {
      const { country } = this.parent
      if (!value || !country) return true
      return zipLengthRules[country]?.test(value) ?? true
    })
    .required("PSČ je povinné."),
  country: yup
    .string()
    .oneOf(getCountries().map(({ code }) => code))
    .required("Země je povinná."),
  registration_no: yup.string().test("is-valid-registration-no", "Neplatné IČO pro vybranou zemi", function (value) {
    const { country } = this.parent
    if (!value || !country) return true
    return registrationNoRules[country]?.test(value) ?? true
  }),
  vat_no: yup.string().test("is-valid-vat-no", "Neplatné DIČ pro vybranou zemi", function (value) {
    const { country } = this.parent
    if (!value || !country) return true
    return vatNoRules[country]?.test(value) ?? true
  })
})
